import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as rccActions from "../../actions/rccActions";

import PurgeModalComponent from "../../components/global/modal/PurgeModal";

class PurgeModal extends Component {
    closeModal = () => {
        this.props.dispatchCloseModalAction();
    };

    purgeChannels = (channels) => {
        this.props.dispatchPurgeChannelsAction(channels);
    };

    purgeAllChannels = (volume) => {
        this.props.dispatchPurgeAllChannelsAction(volume);
    };

    render() {
        return (
            <PurgeModalComponent
                tabId={this.props.tabId}
                channelList={this.props.channelList}
                colorantList={this.props.colorantList}
                closeModal={this.closeModal}
                purgeChannels={this.purgeChannels}
                purgeAllChannels={this.purgeAllChannels}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        channelList: store.rcc.channelList,
        colorantList: store.global.colorantList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PURGE_MODAL));
        },
        dispatchPurgeChannelsAction: (channels) => {
            dispatch(rccActions.purgeChannels(channels));
        },
        dispatchPurgeAllChannelsAction: (volume) => {
            dispatch(rccActions.purgeAllChannels(volume));
        }
    };
};

export default PurgeModal = connect(mapStoreToProps, mapDispatchToProps)(PurgeModal);
